module.exports = __webpack_public_path__ + "static/TyrannyRebellion-bdc3fe47fc9379f956f780704e4c03c0.jpg";